export function convertProductivityData({ previousTimeFrame = [], currentTimeFrame = [] } = {}, timeFrame) {
    const result = [];
    result.push(formatProductivityArray(currentTimeFrame, timeFrame, 1));
    if (previousTimeFrame && previousTimeFrame.length > 0) {
        result.push(formatProductivityArray(previousTimeFrame, timeFrame, 2));
    }
    return result;
}

function formatProductivityArray(arr, timeFrame, seriesNr) {
    const limit = {
        weeks: 7,
        months: 6,
        year: 12
    };
    const result = {
        name: `seriesNr${seriesNr}`,
        data: [],
        overdue: [],
        atRisk: [],
        attention: [],
        onTrack: [],
        type: "area"
    };
    for (let index = 0; index < limit[timeFrame]; index++) {
        result.data.push({ x: index, y: arr[index] ? arr[index].total : "N/A" });
        result.overdue.push(arr[index] ? arr[index].overdue : "N/A");
        result.atRisk.push(arr[index] ? arr[index].atRisk : "N/A");
        result.attention.push(arr[index] ? arr[index].attention : "N/A");
        result.onTrack.push(arr[index] ? arr[index].onTrack : "N/A");
    }
    return result;
}
